
import * as React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const IOSSwitch = styled(({ colorSwitch, ...props }) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme, colorSwitch }) => {
  const switchColor = colorSwitch || "#77CCCD";

  return {
    width: "52px !important",
    height: "38px !important",
    padding: 7,
    "& .css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase": {
      position: "absolute",
      borderRadius: "50%",
    },
    "& .MuiSwitch-switchBase": {
      padding: 5,
      marginTop: "3px !important",
      transitionDuration: "300ms !important",
      color: "#fff !important",
      "&.Mui-checked": {
        transform: "translateX(16px) !important",
        color: "#fff !important",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark"
              ? `${switchColor} !important`
              : `${switchColor} !important`,
          opacity: "1 !important",
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: "0.8 !important",
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: `${switchColor} !important`,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity:
          theme.palette.mode === "light" ? "0.7 !important" : "0.3 !important",
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box !important",
      width: "22px !important",
      height: "22px !important",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor:
        theme.palette.mode === "light"
          ? "#E9E9EA !important"
          : "#39393D !important",
      opacity: "1 !important",
      transition: theme.transitions.create(["background-color"], {
        duration: "500 !important",
      }),
    },
  };
});

export default IOSSwitch;

